<!-- 积分抽奖 中奖记录 -->
<script setup>
import { mywinApi } from "./helper/api";
import store from "@/store";
import { ref } from "vue";
import { useRouter } from "vue-router";
import { air } from "./helper/import";
import { onMountedOrActivated } from "./helper/onMountedOrActivated";
import { Toast } from "@nutui/nutui";
const items = ref([]);
onMountedOrActivated(async () => {
  const res = await mywinApi({
    lottery_id: store.state.lottery.lottery_id,
    page: { page_no: 1, page_size: 100 },
  });
  // 中奖记录
  items.value = res.data.items;
});
const router = useRouter();
const handleClickItem = (item) => {
  const {
    order_id,
    prize_img_url,
    prize_name,
    prize_number,
    prize_state,
    prize_type,
    win_time,
    draw_id,
  } = item;
  if (prize_type !== "2") return;
  if (prize_state === "2") {
    if (typeof order_id !== "string") {
      Toast.text("order_id非法");
      return;
    }
    // 已经兑换了，直接去兑换详情页
    window.easyearn.goExchangeDetailPage(order_id);
    return;
  }
  router.push({ name: "Exchange" });
  const obj = {
    order_id,
    prize_img_url,
    prize_name,
    prize_number,
    prize_state,
    prize_type,
    win_time,
    draw_id,
  };
  store.commit("lottery/SET_EX_CHANGE", obj);
};
</script>
<template>
  <div class="wrap">
    <img class="air_icon" :src="air" v-if="items.length === 0" />
    <div
      class="item"
      v-for="item in items"
      :key="item.order_id"
      @click="handleClickItem(item)"
    >
      <div class="item_text">获得{{ item.prize_name }}</div>
      <div class="item_time">{{ item.win_time }}</div>
      <div class="item_line"></div>
      <div v-if="Number(item.prize_type) === 2" class="item_arrow"></div>
    </div>
  </div>
</template>
<style scoped lang="scss">
.wrap {
  max-height: calc(100vh - 80px);
  overflow: auto;
  padding: 10px 0;
  background-color: #f3f3f3;
  .air_icon {
    width: 84px;
    position: absolute;
    top: 260px;
    left: 50%;
    transform: translateX(-50%);
  }

  .item {
    height: 80px;
    background-color: #fefefe;
    padding: 20px 16px;
    position: relative;
    box-sizing: border-box;

    .item_text {
      font-size: 16px;
      color: #000000;
      font-weight: 600;
    }

    .item_time {
      margin-top: 8px;
      font-size: 14px;
      color: #8c8c8c;
    }

    .item_line {
      position: absolute;
      left: 16px;
      right: 16px;
      bottom: 0;
      height: 2px;
      background-color: #f3f3f3;
    }

    .item_arrow {
      width: 6px;
      height: 6px;
      position: absolute;
      top: 50%;
      right: 20px;
      transform: translateY(-50%);
      transform: rotate(-315deg);
      border: 1px solid;
      border-color: rgba(23, 24, 26, 0.7) rgba(23, 24, 26, 0.7) transparent
        transparent;
    }
  }
}
</style>
